<template>
  <div>
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("Ticket Type", 1) }}
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in TicketTypes"
          :key="index"
          v-if="item.fieldname !== 'tt_id'"
          class="col-lg-6 col-xl-4 align-self-center"
        >
          <div v-if="item.fieldname !== 'tt_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <!-- <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span> -->
              <span v-if="submitted && errors.has(item.fieldname)">
                {{ $tc(item.errormsg) }}</span
              >
            </p>
          </div>
          <div v-if="item.fieldname === 'tt_is_active'">
            <div class="row">
              <div class="col-md-3 col-xl-2 align-self-center">
                <label class="mb-0">{{ $t("active") }}</label>
              </div>
              <div class="col-md-9 col-xl-10 align-self-center">
                <label class="ios-switch">
                  <input
                    type="checkbox"
                    class="ios-checkbox"
                    v-model="item.fieldvalue"
                  />
                  <span class="switch-slider"></span>
                </label>
              </div>
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div class="col-12">
          <TranslationsContainer :translationsObj="translationsObj" />
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="ticket-type"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TicketTypes from "@/helper/formJSONMaster/TicketTypes";
import MasterService from "@/services/MasterService";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";

export default {
  components: {
    TranslationsContainer
  },
  data() {
    return {
      btenable: false,
      TicketTypes: TicketTypes.ms_ticket_types,
      // v-validate="'required|email'"
      submitted: false,
      Methods: TicketTypes.Methods,
      translationsObj: {}
    };
  },
  mounted() {
    console.log("TicketTypes :", TicketTypes);
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function() {
      // this.submitted = false;
    },
    resetHandler: function() {
      this.TicketTypes.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody(
            "POST",
            this.TicketTypes,
            this.Methods
          );

          body.payload = {
            ...body.payload,
            translationsObj: this.translationsObj
          };

          console.log("body ticket types :", body);

          MasterService.AddTicketTicketType(body)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (flag) {
                  this.$router.push({
                    path: "ticket-type"
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch(error => {
              this.$toasted.show(data.error);
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TicketType/addTicketType.vue